import * as React from 'react'
const SvgExample = props => <svg {...props} />
export default SvgExample
